// eslint-disable-next-line @nx/enforce-module-boundaries
import { TCommonTableColumnConfig } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellType, TTableOptions, TTableTextCellColors, TTextCell } from '../../table.type';

export const COMMON_TABLE_WRAPPER_MODEL = {
  createModel: (
    rows: any,
    config: TCommonTableColumnConfig[],
    isMobile: boolean = false,
    groupColumnConfig?: { name: string; span: number }[],
    tableProperties?: { summary: boolean; sortable: boolean },
  ) => {
    const options = {
      ...(rows.length > 100 && {
        virtualScroll: {
          itemSize: 63,
          minBufferPx: window.screen.height,
          maxBufferPx: window.screen.height,
        },
      }),
      headerConfig: config.map((col, i) => {
        return {
          type: 'TEXT_CELL',
          text: col.name,
          ...(col.frozenLeft && !isMobile
            ? {
                stickyType: 'LEFT',
                stickyPosition: i,
              }
            : {}),
          widthInPx: col.width,
          align: 'start',
          borderRight: true,
        };
      }),
      ...(tableProperties?.summary && { footerConfig: config.map((col) => getFooterCell(col)) }),
      sort: tableProperties?.sortable,
      ...(groupColumnConfig && {
        grouppedHeaderConfig: {
          type: 'GROUPPED_HEADER',
          cells: groupColumnConfig?.map((col) => ({
            type: 'TEXT_CELL',
            text: col.name,
            span: col.span,
          })),
        },
      }),
    };

    return ModifiersZTableModel.createTableModel(rows, options as unknown as TTableOptions<unknown>, (item) => {
      return {
        type: 'ROW',
        rowItem: item,
        cells: config.map((cell) => getRowCell(cell, item)),
      };
    });
  },
};

const getFooterCell = (table: TCommonTableColumnConfig) => {
  const cell = table.summaryData;
  return getTableCell(table.summaryTemplateType, cell, true);
};

const getRowCell = (table: TCommonTableColumnConfig, row: any): TTableCellType => {
  const cell = row[table.prop];
  return getTableCell(table.cellTemplateType, cell);
};

const getTableCell = (
  templateType: TCommonTableColumnConfig['cellTemplateType'],
  cell: any,
  isSuummaryCell?: boolean,
): TTableCellType => {
  switch (templateType) {
    case 'fraction':
      return {
        type: 'TEXT_CELL',
        text: cell.numerator,
        textColor: COLOR_MAP[cell.numStyle || ''],
        subtitle: {
          text: `/${cell.denominator}`,
          align: 'INLINE',
          fontSize: {
            value: 14,
            unit: 'px',
          },
        },
        align: 'start',
      };
    case 'multiStyleTextIcon':
      return {
        type: 'TEXT_CELL',
        text: cell.value,
        textColor: COLOR_MAP[cell.style || ''],
        icon: ICON_MAP[cell.suffixIconClass as string],
        align: 'start',
      };
    default:
      return {
        type: 'TEXT_CELL',
        text: typeof cell === 'object' ? cell.value : cell,
        textColor: COLOR_MAP[cell.style || ''],
        align: 'start',
      };
  }
};

const COLOR_MAP = {
  'ind-color-green': 'GREEN',
  'ind-color-red': 'RED',
  'ind-color-yellow': 'YELLOW',
} as Record<string, TTableTextCellColors>;

const ICON_MAP = {
  'ioc-green-ind': { type: 'UP', align: 'END' },
  'ioc-red-ind': { type: 'DOWN', align: 'END' },
  'ioc-yellow-ind': { type: 'WARNING', align: 'END' },
  sort: { type: 'SORT', align: 'END' },
} as Record<string, TTextCell['icon']>;
